import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) => {
	return ({
		dragHandle: {
			display: "flex",
			alignItems: "center",
			color: baseColors.gray300,
			cursor: "grab",
		},
		nextChip: {
			backgroundColor: baseColors.teal25,
			color: baseColors.slateTeal,
			fontWeight: 400,
			height: "auto",
			"& .MuiChip-label": {
				paddingLeft: 12,
				paddingRight: 12,
				paddingTop: 4,
				paddingBottom: 4,
			},
		},
		stepper: {
			display: "flex",
			alignItems: "stretch",
			border: `1px solid ${baseColors.gray100}`,
			borderRadius: 4,
			overflow: "hidden",
			width: 120,
			height: 48,
		},
		stepperValue: {
			flex: 1,
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-start",
			padding: "0 16px",
			fontSize: 16,
		},
		stepperButtons: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			width: 44,
			borderLeft: `1px solid ${baseColors.gray100}`,
		},
		stepperButton: {
			padding: 2,
			borderRadius: 0,
		},
	} satisfies Record<string, CSSObject>);
};
